/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as LucidRouteImport } from './routes/lucid'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthResetPasswordRouteImport } from './routes/auth.reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth.forgot-password'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AgentsNewRouteImport } from './routes/agents.new'
import { Route as AgentsAgentIdRouteImport } from './routes/agents.$agentId'
import { Route as AgentsAgentIdSettingsRouteImport } from './routes/agents.$agentId.settings'

const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const LucidRoute = LucidRouteImport.update({
  id: '/lucid',
  path: '/lucid',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsNewRoute = AgentsNewRouteImport.update({
  id: '/agents/new',
  path: '/agents/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAgentIdRoute = AgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAgentIdSettingsRoute = AgentsAgentIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AgentsAgentIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/lucid': typeof LucidRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/agents/$agentId': typeof AgentsAgentIdRouteWithChildren
  '/agents/new': typeof AgentsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/agents/$agentId/settings': typeof AgentsAgentIdSettingsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/lucid': typeof LucidRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/agents/$agentId': typeof AgentsAgentIdRouteWithChildren
  '/agents/new': typeof AgentsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/agents/$agentId/settings': typeof AgentsAgentIdSettingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/lucid': typeof LucidRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/agents/$agentId': typeof AgentsAgentIdRouteWithChildren
  '/agents/new': typeof AgentsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/agents/$agentId/settings': typeof AgentsAgentIdSettingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/lucid'
    | '/settings'
    | '/signin'
    | '/agents/$agentId'
    | '/agents/new'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/agents/$agentId/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/lucid'
    | '/settings'
    | '/signin'
    | '/agents/$agentId'
    | '/agents/new'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/agents/$agentId/settings'
  id:
    | '__root__'
    | '/'
    | '/lucid'
    | '/settings'
    | '/signin'
    | '/agents/$agentId'
    | '/agents/new'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/agents/$agentId/settings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LucidRoute: typeof LucidRoute
  SettingsRoute: typeof SettingsRoute
  SigninRoute: typeof SigninRoute
  AgentsAgentIdRoute: typeof AgentsAgentIdRouteWithChildren
  AgentsNewRoute: typeof AgentsNewRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lucid': {
      id: '/lucid'
      path: '/lucid'
      fullPath: '/lucid'
      preLoaderRoute: typeof LucidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/new': {
      id: '/agents/new'
      path: '/agents/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof AgentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agentId': {
      id: '/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AgentsAgentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agentId/settings': {
      id: '/agents/$agentId/settings'
      path: '/settings'
      fullPath: '/agents/$agentId/settings'
      preLoaderRoute: typeof AgentsAgentIdSettingsRouteImport
      parentRoute: typeof AgentsAgentIdRoute
    }
  }
}

interface AgentsAgentIdRouteChildren {
  AgentsAgentIdSettingsRoute: typeof AgentsAgentIdSettingsRoute
}

const AgentsAgentIdRouteChildren: AgentsAgentIdRouteChildren = {
  AgentsAgentIdSettingsRoute: AgentsAgentIdSettingsRoute,
}

const AgentsAgentIdRouteWithChildren = AgentsAgentIdRoute._addFileChildren(
  AgentsAgentIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LucidRoute: LucidRoute,
  SettingsRoute: SettingsRoute,
  SigninRoute: SigninRoute,
  AgentsAgentIdRoute: AgentsAgentIdRouteWithChildren,
  AgentsNewRoute: AgentsNewRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
